const useScrollTo = (ref) => {
  window.scrollTo({
    top: ref?.current?.offsetTop - 170, //default: top of the page
    behavior: 'smooth',
  });
};

export default useScrollTo;